module.exports={account_link_complete_message:"Se completó la vinculación de la cuenta Nexon."};